export type TestMenuSource = 'prod-copy' | 'staging'

export type TestMenu = {
  slug: string
  name: string
  source: TestMenuSource
  categories: number
  products: number
  sections: number
  photoPercent: number
  hasDarkTheme: boolean
}

// Snapshot of the staging database taken on 2026-09-10: visible categories, visible parent products,
// menu sections (1 means sections are enabled but only the default one exists) and the share of
// products with a photo. Prod copies first, then the 20 largest staging accounts with 4+ categories.
export const TEST_MENUS: TestMenu[] = [
  {
    slug: 'logout',
    name: 'Log Out',
    source: 'prod-copy',
    categories: 46,
    products: 471,
    sections: 2,
    photoPercent: 34,
    hasDarkTheme: false,
  },
  {
    slug: 'terasadelacase',
    name: 'Terasa de la Case',
    source: 'prod-copy',
    categories: 19,
    products: 121,
    sections: 2,
    photoPercent: 66,
    hasDarkTheme: false,
  },
  {
    slug: 'supremeburger',
    name: 'Supreme Burger',
    source: 'prod-copy',
    categories: 13,
    products: 99,
    sections: 2,
    photoPercent: 75,
    hasDarkTheme: false,
  },
  {
    slug: 'laresidenza',
    name: 'La Residenza',
    source: 'prod-copy',
    categories: 6,
    products: 28,
    sections: 1,
    photoPercent: 82,
    hasDarkTheme: false,
  },
  {
    slug: 'lavrion',
    name: 'Lavrion Staging',
    source: 'staging',
    categories: 98,
    products: 526,
    sections: 3,
    photoPercent: 18,
    hasDarkTheme: false,
  },
  {
    slug: 'donrestaurantpizerie',
    name: 'Don. Restaurant & Pizzerie',
    source: 'staging',
    categories: 15,
    products: 292,
    sections: 2,
    photoPercent: 0,
    hasDarkTheme: false,
  },
  {
    slug: 'ambercaffe',
    name: 'Amber Caffe',
    source: 'staging',
    categories: 50,
    products: 217,
    sections: 2,
    photoPercent: 6,
    hasDarkTheme: false,
  },
  {
    slug: 'casabunicii2',
    name: 'Casa Bunicii',
    source: 'staging',
    categories: 31,
    products: 171,
    sections: 3,
    photoPercent: 99,
    hasDarkTheme: false,
  },
  {
    slug: 'pandaexpress',
    name: 'Panda Express',
    source: 'staging',
    categories: 17,
    products: 169,
    sections: 0,
    photoPercent: 0,
    hasDarkTheme: false,
  },
  {
    slug: 'demo',
    name: 'Demo Restaurant',
    source: 'staging',
    categories: 21,
    products: 46,
    sections: 0,
    photoPercent: 67,
    hasDarkTheme: false,
  },
  {
    slug: 'inghetatapebat',
    name: 'Înghețată pe bățuc',
    source: 'staging',
    categories: 11,
    products: 40,
    sections: 2,
    photoPercent: 100,
    hasDarkTheme: false,
  },
  {
    slug: 'bucatealesedinbuzau',
    name: 'Bucate alese din Mousaios',
    source: 'staging',
    categories: 8,
    products: 35,
    sections: 0,
    photoPercent: 0,
    hasDarkTheme: false,
  },
  {
    slug: 'ciocoloco23',
    name: 'Cioco loco 23',
    source: 'staging',
    categories: 5,
    products: 31,
    sections: 2,
    photoPercent: 81,
    hasDarkTheme: false,
  },
  {
    slug: 'freeordering',
    name: 'Free Ordering',
    source: 'staging',
    categories: 5,
    products: 31,
    sections: 1,
    photoPercent: 29,
    hasDarkTheme: false,
  },
  {
    slug: 'meatup',
    name: 'MEAT UP',
    source: 'staging',
    categories: 6,
    products: 28,
    sections: 2,
    photoPercent: 32,
    hasDarkTheme: true,
  },
  {
    slug: 'bistrocrina',
    name: 'MeniuDigital Bistro',
    source: 'staging',
    categories: 9,
    products: 24,
    sections: 2,
    photoPercent: 83,
    hasDarkTheme: false,
  },
  {
    slug: 'devbistro',
    name: 'Dev Bistro',
    source: 'staging',
    categories: 11,
    products: 18,
    sections: 0,
    photoPercent: 28,
    hasDarkTheme: false,
  },
  {
    slug: 'nexttoyouinmalibu',
    name: 'Next to you in Malibu',
    source: 'staging',
    categories: 8,
    products: 12,
    sections: 0,
    photoPercent: 83,
    hasDarkTheme: false,
  },
  {
    slug: 'pubcrina',
    name: 'Pub Crina',
    source: 'staging',
    categories: 11,
    products: 11,
    sections: 4,
    photoPercent: 100,
    hasDarkTheme: false,
  },
  {
    slug: 'huaweibistro',
    name: 'Huawei Bistro',
    source: 'staging',
    categories: 7,
    products: 11,
    sections: 1,
    photoPercent: 0,
    hasDarkTheme: false,
  },
  {
    slug: 'noorders',
    name: 'Cocoșul de Aur / Music Garden',
    source: 'staging',
    categories: 32,
    products: 10,
    sections: 0,
    photoPercent: 40,
    hasDarkTheme: false,
  },
  {
    slug: 'vreaubistro',
    name: 'Vreau Bistro',
    source: 'staging',
    categories: 5,
    products: 10,
    sections: 0,
    photoPercent: 10,
    hasDarkTheme: false,
  },
  {
    slug: 'allowme',
    name: 'Allow Me',
    source: 'staging',
    categories: 5,
    products: 9,
    sections: 0,
    photoPercent: 0,
    hasDarkTheme: false,
  },
  {
    slug: 'newintown',
    name: 'New in Town',
    source: 'staging',
    categories: 4,
    products: 9,
    sections: 2,
    photoPercent: 0,
    hasDarkTheme: false,
  },
]

export const isTestMenusModalEnabled = (process.env.REACT_APP_ENV || 'production').toLowerCase() !== 'production'
